import { render, staticRenderFns } from "./AllContractsPage.vue?vue&type=template&id=651855ee&scoped=true"
import script from "./AllContractsPage.vue?vue&type=script&lang=js"
export * from "./AllContractsPage.vue?vue&type=script&lang=js"
import style0 from "./AllContractsPage.vue?vue&type=style&index=0&id=651855ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651855ee",
  null
  
)

export default component.exports